'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Tablelvl2Context = {};

exports.__exports = Tablelvl2Context;
